import { PiAddressBook } from "react-icons/pi";

export const AddressBookIcon = ({ ...rest }) => {
  return <PiAddressBook {...rest} />;
};
